export const INVALID_MIN_ODD_RESPONSE_CODE = 1011;

export const AdditionalErrorMessages = {
  InValidOdd: 'INVALID_ODD',
};

export const AdditionalNotificationByResponseCode = {
  InValidOdd: 'error',
};

export const AdditionalResponseCode = {
  [INVALID_MIN_ODD_RESPONSE_CODE]: 'InValidOdd',
};
